{
  "toast_saved": "Gespeichert",
  "toast_deleted": "Gelöscht",
  "toast_error": "Fehler",
  "save": "Speichern",
  "saving": "Speichert…",
  "node_unwired": "Noch nicht aktiv — kein Backend-Event-Sender vorhanden",
  "node_not_implemented": "Diese Aktion ist noch nicht verfügbar",
  "dry_run": "Probelauf",
  "dry_run_hint": "Flow gefahrlos mit einem Test-Event durchspielen (keine Aktionen werden real ausgeführt)",
  "dry_run_save_first": "Flow zuerst speichern, dann Probelauf",
  "dry_run_matched": "Probelauf: Trigger trifft zu, {{count}} Aktion(en) würden ausführen",
  "dry_run_not_implemented": "Probelauf: Aktion „{{subtype}}“ ist noch nicht verfügbar",
  "dry_run_no_match": "Probelauf: Trigger trifft nicht zu",
  "toast_save_error": "Speicherfehler",
  "active": "Aktiv",
  "inactive": "Inaktiv",
  "inactiveLabel": "Inaktiv",
  "allAgents": "Alle Agenten",
  "allChannels": "Alle Kanaele",
  "allHeartbeatTasks": "Alle Heartbeat-Tasks",
  "canvasEmptyHint": "Ziehe Knoten aus der Palette auf die Flaeche",
  "canvasEmptySubHint": "Verbinde einen Trigger mit Bedingungen und Aktionen",
  "caseInsensitive": "Gross-/Kleinschreibung ignorieren",
  "channelMissing": "Bitte Kanal auswaehlen",
  "conditionNo": "Nein",
  "conditionYes": "Ja",
  "copyUrl": "URL kopieren",
  "discordChannelIdHint": "Numerische Discord-Kanal-ID eingeben (Rechtsklick → ID kopieren)",
  "flowNamePlaceholder": "Mein Automatisierungs-Flow",
  "groupAction": "Aktionen",
  "groupCondition": "Bedingungen",
  "groupTrigger": "Trigger",
  "ignoreInfo": "Nachrichten die dieser Bedingung entsprechen werden ignoriert",
  "instructionPassedHint": "Die Trigger-Nachricht wird als Anweisung an den Agenten uebergeben",
  "labelAgent": "Agent",
  "labelBodyJson": "Body (JSON)",
  "labelChannel": "Kanal",
  "labelChannelId": "Kanal-ID",
  "labelComment": "Kommentar",
  "labelDays": "Tage",
  "labelDescription": "Beschreibung",
  "labelFieldDotNotation": "Feld (Punkt-Notation)",
  "labelFrom": "Von",
  "labelInstruction": "Anweisung",
  "labelIssueNumber": "Issue-Nummer",
  "labelKeyword": "Schluesselwort",
  "labelMessage": "Nachricht",
  "labelRecipient": "Empfaenger",
  "labelReplyText": "Antworttext",
  "labelRepo": "Repository",
  "labelSubject": "Betreff",
  "labelTargetUrl": "Ziel-URL",
  "labelTaskId": "ID der Intervallaufgabe (optional)",
  "labelText": "Text",
  "labelTitle": "Titel",
  "labelTo": "Bis",
  "labelValueContains": "Wert enthaelt",
  "labelWebhookUrl": "Webhook-URL",
  "newFlowName": "Neuer Flow",
  "newFlowOption": "Neuen Flow erstellen",
  "nodePalette": "Knoten-Palette",
  "overnightSupported": "Nachtschichten werden unterstuetzt (z.B. 22:00–06:00)",
  "paletteDragHint": "Knoten auf die Flaeche ziehen",
  "placeholderFieldExample": "z.B. pull_request.title",
  "placeholderHint": "Eingabe starten...",
  "placeholderInstructionExample": "z.B. Fasse die Nachricht zusammen und antworte",
  "placeholderKeywordExample": "z.B. dringend",
  "placeholderRecipientExample": "z.B. user@example.com",
  "placeholderReplyExample": "z.B. Danke, ich kuemmere mich darum!",
  "placeholderSubjectExample": "z.B. Rechnung",
  "placeholderTaskIdExample": "z.B. heartbeat-daily",
  "placeholderTriggeredBy": "Ausgeloest von...",
  "placeholderValueExample": "z.B. erwarteter Wert",
  "postToTrigger": "An Trigger senden",
  "properties": "Eigenschaften",
  "queueInfo": "Nachrichten werden der Reihe nach verarbeitet",
  "removeNode": "Knoten entfernen",
  "replyDirectHint": "Die Antwort wird direkt an die Quelle der Trigger-Nachricht gesendet",
  "repoMissing": "Bitte Repository eingeben",
  "selectAgent": "Agent auswaehlen",
  "smtpHint": "SMTP-Einstellungen werden in der E-Mail-Integration des Agenten konfiguriert",
  "toMissing": "Bitte Empfaenger eingeben",
  "urlMissing": "Bitte URL eingeben",
  "nodeMessageReceived": "Nachricht empfangen",
  "nodeWebhookReceived": "Webhook empfangen",
  "nodeHeartbeatTask": "Heartbeat-Task",
  "nodeTimeWindow": "Zeitfenster",
  "nodeDayOfWeek": "Wochentag",
  "nodeMessageContains": "Nachricht enthaelt",
  "nodePayloadFieldContains": "Payload-Feld enthaelt",
  "nodeAgentReply": "Agent antwortet",
  "nodeAgentReplyGuided": "Agent antwortet (gefuehrt)",
  "nodeReplyFixed": "Feste Antwort",
  "nodeQueue": "In Warteschlange",
  "nodeIgnore": "Ignorieren",
  "nodeForward": "Weiterleiten",
  "nodeHttpPost": "HTTP POST",
  "nodeSendEmail": "E-Mail senden",
  "nodeGitCreateIssue": "Git-Issue erstellen",
  "nodeGitAddComment": "Git-Kommentar",
  "nodeDiscordPost": "Discord-Nachricht",
  "badge_soon": "bald",
  "toast_unwired": "„{{subtype}}“ ist noch ein Platzhalter und tut nichts. Bitte entfernen, dann speichern.",
  "nodeCronFired": "Zeitplan (Cron)",
  "nodeRegexMatch": "Regex-Treffer",
  "labelCron": "Cron-Ausdruck",
  "cronUtcHint": "Minute Stunde Tag Monat Wochentag — Zeiten in UTC (MEZ = UTC+1, MESZ = UTC+2)",
  "cronMissing": "Cron fehlt",
  "labelRegex": "Regulärer Ausdruck",
  "regexHint": "Wird gegen den Nachrichtentext geprüft, Groß-/Kleinschreibung zählt",
  "webhookAnyHint": "Jeder Webhook des Projekts",
  "webhookNeedsProject": "Dieser Trigger braucht ein Projekt. Öffne den Butler aus dem Projekt-Cockpit, dann steht hier die Webhook-URL.",
  "webhookSecretHint": "Der Aufruf braucht den Header X-Webhook-Secret. Das Secret steht im Projekt-Cockpit unter Integrationen."
}
